/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { CardApartmentProps } from 'components/CardApartment/CardApartment';
import type { Quote } from 'types/quote';

type ConfigurationsState = {
  configurations: CardApartmentProps[];
  isLoading: boolean;
  hasError: boolean;
};

const initialState: ConfigurationsState = {
  configurations: [],
  isLoading: false,
  hasError: false,
};
const slice = createSlice({
  name: 'configurations',
  initialState,
  reducers: {
    setConfigurations: (state, action: PayloadAction<CardApartmentProps[]>) => {
      state.configurations = action.payload;
    },
    loadingRequired: (state) => {
      state.isLoading = true;
    },
    loadingStopRequired: (state) => {
      state.isLoading = false;
    },
  },
});

export const { setConfigurations, loadingRequired, loadingStopRequired } = slice.actions;

export const { reducer } = slice;
